// HomeFaq.jsx
import React from "react";
import "./../../css/HomeFaq.css";
import Accordion from "./../../ui/Accordion"; // Adjust path if needed
import Container from "./../../ui/container";
import Heading from "./../../ui/heading";
import { FaqImage } from "../../assets/images";

const HomeFaq = () => {
  return (
    <section className='home-faq-section'>
      <Container className='home-faq-container'>
        <div className='home-faq-img'>
          <img src={FaqImage} className='home-faq-img-content' alt='FAQ' />
        </div>
        <div className='home-faq-content'>
          <Heading variant='H2'>Frequently Asked Questions</Heading>
          <p className='home-faq-text'>
            PS Environmental provides expert services in air pollution control
            and dust collection systems. If you don’t see your question here,
            feel free to reach out—we’re just an email away!
          </p>
          <div className='home-faq-accordion'>
            <Accordion items={ACCORDION_ITEMS} />
          </div>
        </div>
      </Container>
    </section>
  );
};

const ACCORDION_ITEMS = [
  {
    title: "Do you offer emergency repair services?",
    content: (
      <p>
        Yes, we provide rapid emergency response services to minimize downtime
        and restore system functionality—especially for clients with Master
        Service Contracts.
      </p>
    ),
  },
  {
    title: "Can you help ensure compliance with regulations like OSHA and EPA?",
    content: (
      <p>
        Absolutely. Our engineering evaluations include performance diagnostics
        and compliance analysis to help you meet OSHA, EPA, and MACT standards.
      </p>
    ),
  },
  {
    title: "What’s included in your preventive maintenance plans?",
    content: (
      <p>
        Our PM plans include filter checks, leak testing, valve inspections, fan
        maintenance, gasket replacements, and scheduled filter change forecasts.
      </p>
    ),
  },
  {
    title: "Do you provide filter bags and replacement parts?",
    content: (
      <p>
        Yes, we maintain a large inventory of filter bags and essential parts,
        ensuring quick delivery and proper fit for your system.
      </p>
    ),
  },
];

export default HomeFaq;
